// extracted by mini-css-extract-plugin
export default {"footer":"EnterBottomLinks_footer__82Vdq","question":"EnterBottomLinks_question__hIXZV","enterId":"EnterBottomLinks_enterId__MYzb-"};